/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Incidents_Col_IncidentInputs */



/**
* | output |
* | --- |
* | "Incident" |
*
* @param {Partner_Status_Incidents_Col_IncidentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_incidents_col_incident = /** @type {((inputs?: Partner_Status_Incidents_Col_IncidentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Incidents_Col_IncidentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Störung")
	return /** @type {LocalizedString} */ ("Incident")
});